import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import BKButton from '@/components/AppShared/BKButton.vue'
import { eventApi, EventDB } from '@/enitites/event'
import ToggleLike from '@/features/toggle-like/ui/ToggleLike.vue'
import { EventFeedbackPostData } from '@/enitites/event/model/types'
import { useRouter } from 'vue-router/composables'
import { EVENT_STAR_CONFIG } from '../constants'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventFeedbackForm',
  props: {
    setFeedback: null,
    event: null
  },
  setup(__props: any) {

const props = __props as {
  setFeedback: (feedback: EventFeedbackPostData) => void
  event: EventDB
};



const router = useRouter()

const isUpdate = computed(() => props.event.feedback)

const isLoading = ref(false)
const feedbackText = ref(props.event?.feedback?.details || '')
const showValidationError = ref(false)

const ratingCategories = ref([
  { key: 'timeliness', label: 'Timeliness', value: props.event.feedback?.timeliness || 0 },
  { key: 'communication', label: 'Communication', value: props.event.feedback?.communication || 0 },
  { key: 'venue', label: 'Venue', value: props.event.feedback?.venue || 0 },
  { key: 'vibe', label: 'Vibe', value: props.event.feedback?.vibe || 0 },
  { key: 'musicSound', label: 'Music / Sound', value: props.event.feedback?.musicSound || 0 },
])

const isFormValid = computed(() => {
  return ratingCategories.value.every((category) => category.value > 0)
})

function handleFeedbackClose() {
  router.push({
    name: 'Event',
    params: { id: `${props.event?.id}` },
    query: { tab: 'info' },
  })
}

const handleSubmitFeedback = async () => {
  if (!isFormValid.value) {
    showValidationError.value = true
    return
  }

  showValidationError.value = false
  isLoading.value = true

  try {
    const ratings = Object.fromEntries(ratingCategories.value.map((cat) => [cat.key, cat.value])) as {
      timeliness: number
      communication: number
      venue: number
      vibe: number
      musicSound: number
    }

    const averageRating = (
      ratingCategories.value.reduce((sum, cat) => sum + cat.value, 0) / ratingCategories.value.length
    ).toFixed(2)

    const data = {
      averageRating: parseFloat(averageRating),
      timeliness: ratings.timeliness,
      communication: ratings.communication,
      musicSound: ratings.musicSound,
      venue: ratings.venue,
      vibe: ratings.vibe,
      details: feedbackText.value.trim(),
    }

    await eventApi.postFeedback(props.event.id, data)
    handleFeedbackClose()
    props.setFeedback(data)
  } catch (error) {
    console.error('Error submitting feedback:', error)
  } finally {
    isLoading.value = false
  }
}

const handleRatingChange = () => {
  if (showValidationError.value && isFormValid.value) {
    showValidationError.value = false
  }
}

return { __sfc: true,props, router, isUpdate, isLoading, feedbackText, showValidationError, ratingCategories, isFormValid, handleFeedbackClose, handleSubmitFeedback, handleRatingChange, BKButton, ToggleLike, EVENT_STAR_CONFIG }
}

})